import { productTypes } from "../../store/constants"

export default {
  mergeContent: function(allContent, locale) {
    // Merge the results of the two separate API calls
    const Contentful_response = JSON.parse(JSON.stringify(allContent[0]))
    const BleachAPI_response = JSON.parse(JSON.stringify(allContent[1]))

    let mergedContent_all = {}

    // For each product type in the Contentful product response
    Object.entries(Contentful_response).forEach(contentType => {
      // Take each collection of products

      const contentType_id = contentType[0]
      const contentType_entries = contentType[1]

      let mergedContent_byType = {}

      Object.entries(contentType_entries).forEach(entry => {
        // For each product, merge the object data with the corresponding product object coming from BleachAPI

        const entry_id = entry[0]
        const entry_data = entry[1]

        // If there's a corresponding product coming from BleachAPI, merge 'em
        if (Object.values(productTypes).includes(contentType_id)) {
          // if entry is a product, set, or gift card
          // console.log("env?", process.env.NODE_ENV)

          const currentMarketId = locale.market?.id
          Bleach.debug.log("entry_data", entry_data, currentMarketId)
          const _variants = entry_data.productVariantsCollection?.items

          const productShouldBeActiveInCurrentMarket = _variants?.find(
            variant => {
              const marketData = Array.isArray(variant.marketData)
                ? variant.marketData
                : []
              return marketData.map(item => item.id).includes(currentMarketId)
            }
          )
          Bleach.debug.log(
            "productShouldBeActiveInCurrentMarket",
            currentMarketId,
            productShouldBeActiveInCurrentMarket
          )
          const productIsWaitlistedInCurrentMarket = !!_variants?.find(
            variant => {
              const marketData = Array.isArray(variant.marketData)
                ? variant.marketData
                : []
              const currentMarketData = marketData.find(
                item => item.id === currentMarketId
              )
              return currentMarketData && currentMarketData.waitlist == true
            }
          )
          if (
            BleachAPI_response[contentType_id] &&
            BleachAPI_response[contentType_id][entry_id] &&
            // If showOnStorefront is not set (backwards compatibility)
            (process.env.VUE_APP_DEV_ENV !== "production" ||
              entry_data.showOnStorefront !== false)
          ) {
            mergedContent_byType[entry_id] = Object.assign(
              {},
              entry_data,
              BleachAPI_response[contentType_id][entry_id],
              { isWaitlisted: productIsWaitlistedInCurrentMarket }
            )
          } else {
            // const currentMarketId = locale.market?.id
            // const productShouldBeActiveInCurrentMarket = !!entry_data.productVariantsCollection.items.find(variant => {
            //   return variant.marketData.map(item => item.id).includes(currentMarketId)
            // })
            // If the productVariant's marketData includes the current market
            if (productShouldBeActiveInCurrentMarket) {
              Bleach.debug.warn(
                `Product data mismatch: ${entry_data.__typename} ${entry_id} ${entry_data.name}`,
                entry_data
              )
            }
          }
        } else {
          mergedContent_byType[entry_id] = entry_data
        }
      })

      // Assign the merged product to the 'output' collection
      mergedContent_all[contentType_id] = mergedContent_byType
    })

    return mergedContent_all
  }
}
